import React from 'react';
import { Link } from 'gatsby';
import * as routes from '../shared/routes';
import Layout from '../components/Layout';
import WhoWeAre from '../components/WhoWeAre';

const Page = () => (
  <Layout>
    <div className="ContentPageLayout">
      <nav className="ContentPageLayout-breadcrumb">
        <Link className="Link" to={routes.HOME}>
          Inicio
        </Link>{' '}
        <span className="ContentPageLayout-arrow">></span>
        <a className="Link" href={typeof window !== `undefined` && window.location.href}>
          Quiénes somos
        </a>
      </nav>
      <WhoWeAre />
    </div>
  </Layout>
);

export default Page;
